<template>
  <div class="app-container" id="courseFileList">
    <div class="mycontainer">
      <el-form
        ref="queryForm"
        :model="listQuery"
        :inline="true"
        label-width="80px"
      >
        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click="addDialog = true"
            >新增</el-button
          >
        </span>
      </el-form>
    </div>
    <div>
      <el-table
        :max-height="height"
        v-loading="this.listLoading"
        :data="this.list"
        fit
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="操作"
          min-width="120"
          align="center"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              plain
              @click="handleEdit(scope.row)"
              style="margin-left: 5px"
              >编辑</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          label="属性名"
          align="left"
          prop="ename"
          min-width="100px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="属性中文名"
          align="left"
          prop="cname"
          min-width="200px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="属性类型"
          align="left"
          prop="type"
          min-width="80px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="默认值"
          align="left"
          prop="defaultValue"
          min-width="120px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="系统默认属性"
          align="left"
          prop="def"
          min-width="60px"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="是否必填"
          align="left"
          prop="required"
          min-width="60px"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="占据列数"
          align="left"
          prop="span"
          min-width="60px"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="排序"
          align="left"
          prop="px"
          min-width="60px"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="this.total > 0"
        :total="this.total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="新增表单"
      :visible.sync="addDialog"
      width="800px"
      v-if="addDialog"
      id="mx-dialog"
    >
      <AddProp
        :mxParams="mxParams"
        ref="addProp"
        @getParentForm="getList"
      ></AddProp>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addPropForm">确定</el-button>
        <el-button @click="addDialog = false">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="编辑表单"
      :visible.sync="editDialog"
      width="800px"
      v-if="editDialog"
      id="mx-dialog"
    >
      <EditProp
        :mxParams="mxParams"
        ref="editProp"
        @getParentForm="getList"
      ></EditProp>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editPropForm">确定</el-button>
        <el-button @click="editDialog = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Pagination from "@/components/Pagination";
import { getDictData } from "@/api/task.js";
import { listProp } from "@/api/meta.js";
import AddProp from "./addProp.vue";
import EditProp from "./editProp.vue";
import { formatMomentDate } from "@/utils/utils";

export default {
  // 列表分页
  components: {
    Pagination,
    AddProp,
    EditProp,
  },
  name: "propList",
  data() {
    return {
      type: "0",
      height: 100,
      total: 0,
      listLoading: true,
      list: [],

      listQuery: {
        metaId: null,
        page: 1,
        pageSize: 50,
      },

      addDialog: false,
      editDialog: false,
    };
  },
  computed: {
    ...mapGetters(["course"]),
  },
  created() {
    this.listQuery.metaId = this.$route.params.metaId;
    this.getList();
  },
  methods: {
    getList() {
      this.addDialog = false;
      this.editDialog = false;

      listProp(this.listQuery).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          this.total = res.count;
          this.listLoading = false;
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 165;
        }
      });
    },

    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },

    handleEdit(row) {
      this.editDialog = true;
      this.mxParams = row;
    },

    addPropForm() {
      this.$refs.addProp.saveForm();
    },
    editPropForm() {
      this.$refs.editProp.saveForm();
    },
  },
};
</script>
<style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.red {
  color: #ff0000 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.grey {
  color: #606266 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.grey2 {
  color: #999 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}

.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}

#save-form .el-form-item {
  margin-bottom: 20px;
}
.row {
  margin-top: 15px;
  .title {
    height: 44px;
    background-color: #d7d7d7;
    padding-left: 15px;
    font-size: 16px;
    line-height: 44px;
    margin-bottom: 15px;
  }
  .step-wrap {
    padding: 0 10%;
  }
  .apply-info {
    display: flex;
    height: 44px;
    line-height: 44px;
    .item {
      padding: 0 50px;
    }
    div {
      display: flex;
    }
  }
}
.myRadio {
  margin-right: 5px;
}
.gray {
  background-color: #ddd;
  border-color: #ddd;
}
</style>
